import { render, staticRenderFns } from "./NotariusActionCard.vue?vue&type=template&id=e9b05b1c&scoped=true&"
import script from "./NotariusActionCard.vue?vue&type=script&lang=js&"
export * from "./NotariusActionCard.vue?vue&type=script&lang=js&"
import style0 from "./NotariusActionCard.vue?vue&type=style&index=0&id=e9b05b1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b05b1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
